import { createStore } from 'vuex'

import authModule from "./modules/authModule"
import scheduleModule from "./modules/scheduleModule"
import manageUsersModule from "./modules/manageUsersModule"
import manageTeamsModule from "./modules/manageTeamsModule"
import manageScheduleGroupsModule from "./modules/manageScheduleGroupsModule"
import invitationsModule from "./modules/invitationsModule"
import notificationsModule from "./modules/notificationsModule"
import scheduleDaysModule from './modules/scheduleDaysModule'
import integrationsModule from './modules/integrationsModule'
import remindersModule from './modules/remindersModule'
import userIntegrationSettingsModule from './modules/userIntegrationSettingsModule'
import actionLogsModule from './modules/actionLogsModule'
import userPreferencesModule from "./modules/userPreferencesModule"
import maestroUsersModule from "./modules/maestroUsersModule"
import sessionsModule from "./modules/sessionsModule"
import sidebarModule from "./modules/sidebarModule"
import pushModule from "./modules/pushModule"
import systemModule from "./modules/systemModule"
import unavailabilitiesModule from "./modules/unavailabilitiesModule"
import burnoutModule from "./modules/burnoutModule"
import feedbacksModule from "./modules/feedbacksModule"

import userPreferencesPersist from "@/utils/userPreferencesPersist"

export {
  authModule,
  scheduleModule,
  manageUsersModule,
  manageTeamsModule,
  manageScheduleGroupsModule,
  invitationsModule,
  notificationsModule,
  scheduleDaysModule,
  integrationsModule,
  remindersModule,
  userIntegrationSettingsModule,
  actionLogsModule,
  userPreferencesModule,
  maestroUsersModule,
  sessionsModule,
  sidebarModule,
  pushModule,
  systemModule
}

export default createStore({
  state: {
    layout: "Base"
  },
  getters: {},
  mutations: {
    setLayout(state, layout) {
      state.layout = layout
    }
  },
  actions: {},
  modules: {
    auth: authModule,
    schedule: scheduleModule,
    manageUsers: manageUsersModule,
    manageTeams: manageTeamsModule,
    manageScheduleGroups: manageScheduleGroupsModule,
    invitations: invitationsModule,
    notifications: notificationsModule,
    scheduleDays: scheduleDaysModule,
    integrations: integrationsModule,
    reminders: remindersModule,
    userIntegrationSettings: userIntegrationSettingsModule,
    actionLogs: actionLogsModule,
    userPreferences: userPreferencesModule,
    maestroUsers: maestroUsersModule,
    sessions: sessionsModule,
    sidebar: sidebarModule,
    push: pushModule,
    system: systemModule,
    unavailabilities: unavailabilitiesModule,
    burnout: burnoutModule,
    feedbacks: feedbacksModule
  },
  plugins: [userPreferencesPersist]
})
